var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 2H12.0455C9.78611 2 7.95455 3.79086 7.95455 6V8.4H5.5V11.6H7.95455V18H11.2273V11.6H13.6818L14.5 8.4H11.2273V6C11.2273 5.55817 11.5936 5.2 12.0455 5.2H14.5V2Z","fill":"currentColor"}));
}

FacebookInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","color":"#161633","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
